import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#0F0F0F] vignette"
    >
      {/* spotlight */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 45%, rgba(255,230,200,0.06), transparent 60%)",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 flex flex-col items-center px-6"
      >
        <img
          src="/hero-sign.png"
          alt="hands holding a crumpled cardboard sign that reads i hate wood mulch"
          data-testid="hero-image"
          className="w-[78vw] max-w-[560px] sm:max-w-[620px] select-none pointer-events-none drop-shadow-[0_30px_80px_rgba(0,0,0,0.8)]"
          draggable="false"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.0, duration: 1.6 }}
        className="absolute bottom-10 left-0 right-0 flex flex-col items-center gap-3 z-10"
      >
        <span
          className="text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#A3A3A3]"
          data-testid="hero-scroll-cue"
        >
          scroll to find out why
        </span>
        <ChevronDown className="scroll-cue text-[#E8E5DE]" size={22} strokeWidth={1.5} />
      </motion.div>

      {/* fade into next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-[#0F0F0F] pointer-events-none" />
    </section>
  );
}
